/**
 * safeJsonLd — stringify a JSON-LD payload and neutralize sequences that
 * could terminate the surrounding <script> tag or start an HTML comment.
 *
 * Even when the input is fully controlled by us, defence-in-depth is cheap
 * insurance against future reviewers piping user-supplied strings into a
 * schema builder. Returns a plain string suitable for passing into
 * dangerouslySetInnerHTML={{ __html: safeJsonLd(obj) }}.
 */
export function safeJsonLd(obj) {
  return JSON.stringify(obj)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

export default safeJsonLd;
